import React from "react"
import styled from "styled-components"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import StyledSmallTitle from "../styled/styledSmallTitle"
import Title from "../Title"
import Paragraph from "../styled/styledParagraph"
import { StyledButton } from "../Button"
import wifiImg from "../../images/icons/about-us/wifi-tethering.svg"
import chatImg from "../../images/icons/about-us/chat.svg"
import accessImg from "../../images/icons/about-us/access-time.svg"
import fibrerSmartImg from "../../images/icons/about-us/fiber-smart-record.svg"
import timelapseImg from "../../images/icons/about-us/timelapse.svg"
import lineStyleImg from "../../images/icons/about-us/line-style.svg"

const StyledSection = styled.section`
  padding: 32px 16px 48px;
  background-color: #fffcfa;
  @media (min-width: 768px) {
    width: 576px;
    margin: 0 auto;
  }
  @media (min-width: 1024px) {
    width: 900px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 65px;
    justify-content: space-between;
    padding: 80px 16px 48px;
  }
  @media (min-width: 1200px) {
    width: 1200px;
    grid-column-gap: 130px;
  }
`
const Container = styled.div`
  ${Paragraph} {
    padding-right: 16px;
  }
  ${Paragraph}:last-child {
    margin-top: 29px;
  }
`
const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  ${StyledButton}:first-child {
    margin: 8px 0 16px;
    padding: 10px 0;
  }
  &.pc-buttons {
    display: none;
    flex-direction: row;
    ${StyledButton}:first-child {
      margin: 0 30px 0 0;
    }
    @media (min-width: 1024px) {
      display: flex;
      flex-direction: row;
      width: 100%;
      margin-top: 40px;
      ${StyledButton} {
        width: 100%;
        max-width: 220px;
      }
    }
  }
  @media (min-width: 1024px) {
    display: none;
  }
`
const List = styled.ul`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  & li {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    & img {
      width: 27px;
      height: 27px;
      @media (min-width: 1024px) {
        width: 35px;
        height: 35px;
      }
    }
    & p {
      font-family: "Made Medium", sans-serif;
      font-size: 20px;
      letter-spacing: 0.25px;
      margin-left: 10px;
      @media (min-width: 1024px) {
        font-size: 24px;
        margin-left: 16px;
      }
    }
  }
  @media (min-width: 1024px) {
    justify-content: space-between;
  }
`
const HowWeWork = () => {
  return (
    <StyledSection>
      <Container>
        <StyledSmallTitle>JAK PRACUJEMY</StyledSmallTitle>
        <Title>
          Nie ma nic prostszego,
          <br /> <span>niż współpraca z nami.</span>
        </Title>
        <Paragraph>
          Nasz przepis na idealną współprace jest bardzo prosty: Twój pomysł +
          nasze wykonanie = Twój sukces. Postaramy się spełnić każde z Twoich
          zaleceń, jednak doradzimy Ci jeśli będzie możliwość zastosowania
          skuteczniejszego rozwiązania.
        </Paragraph>
        <Paragraph>
          Na bieżąco będziemy informować Cię o wszystkich zmianach wprowadzonych
          do projektu. Dołącz do grona naszych klientów i zwiększ swoje
          możliwości już dzisiaj!
        </Paragraph>
        <Buttons className="pc-buttons">
          <StyledButton
            style={{ boxShadow: "0 2px 8px 0 rgba(71, 77, 196, 0.5)" }}
            as={AnchorLink}
            to="/#kontakt"
          >
            Zatrudnij nas
          </StyledButton>
          <StyledButton secondary sameColor as={AnchorLink} to="/#realizacje">
            Zobacz Realizacje
          </StyledButton>
        </Buttons>
      </Container>
      <List>
        <li>
          <img
            src={wifiImg}
            alt="Dostęp do projektu"
            title="Przejrzyste warunki i kompletny wgląd do projektu"
          />
          <p>Ciągły dostęp zdalny do projektu</p>
        </li>
        <li>
          <img
            src={chatImg}
            alt="Stałe doradztwo"
            title="Doradzimy i dobierzemy odpowiednie rozwiązanie"
          />
          <p>Fachowe doradztwo i sugestie</p>
        </li>
        <li>
          <img
            src={timelapseImg}
            alt="Jasne warunki umowy"
            title="Szczegółowo omówimy twoje zlecenie- od początku do końca"
          />
          <p>Elastyczne terminy i zakres prac</p>
        </li>
        <li>
          <img
            src={fibrerSmartImg}
            alt="Ewentualne poprawki będą zawsze brane pod uwage i odpowiednio wdrażane"
            title="Nie boimy się żadnych poprawek w projekcie!"
          />
          <p>Proste wprowadzanie poprawek</p>
        </li>
        <li>
          <img
            src={accessImg}
            alt="Poprowadzimy twój produkt do sukcjesu"
            title="Chcemy aby twój produkt przynosił zysk"
          />
          <p>Opcja dalszej opieki produktem</p>
        </li>
        <li>
          <img
            src={lineStyleImg}
            alt="Odpowiemy na każde pytanie"
            title="Omówimy każdą twoją wątpliwość"
          />
          <p>Wyjaśniamy co, jak i dlaczego</p>
        </li>
      </List>
      <Buttons>
        <StyledButton secondary sameColor as={AnchorLink} to="/#realizacje">
          Zobacz Realizacje
        </StyledButton>
        <StyledButton
          style={{ boxShadow: "0 2px 8px 0 rgba(71, 77, 196, 0.5)" }}
          as={AnchorLink}
          to="/#kontakt"
        >
          Zatrudnij nas
        </StyledButton>
      </Buttons>
    </StyledSection>
  )
}

export default HowWeWork
